/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    isPendingBudgetViewer() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.pendingBudgetViewerRoles;
      return this.memberOf.filter((item) => viewerRoles.includes(item.displayName)).length > 0;
    },
    isProjectsPendingApprovalViewer() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.projectsPendingApprovalViewerRoles;
      return this.memberOf.filter((item) => viewerRoles.includes(item.displayName)).length > 0;
    },
    isSiteAssessmentsPendingApprovalViewer() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.siteAssessmentsPendingApprovalViewerRoles;
      return this.memberOf.filter((item) => viewerRoles.includes(item.displayName)).length > 0;
    },
    isWorkorderBillsPendingApprovalViewer() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.workorderBillsPendingApprovalViewerRoles;
      return this.memberOf.filter((item) => viewerRoles.includes(item.displayName)).length > 0;
    },
  },
};
